import React, { PureComponent } from 'react';
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from "@material-ui/core/Typography";
import EventBusyIcon from '@material-ui/icons/EventBusy';

const useStyles = makeStyles((theme) => ({
    card: {
        color: '#616161',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        width: '100%',
        height: '48px',
    },
    cardContent: {
        display: 'flex',
    },
    icon: {
        padding: '12px 16px',
    },
    text: {
        fontSize: '14px',
        fontWeight: 500,
        textAlign: 'left',
        padding: '12px 0px',
    },
}));

class DealExpiredBox extends PureComponent {
    render() {
        const { classes, text } = this.props;
        return (
            <Card className={classes.card} elevation={11}>
                <CardContent className={classes.cardContent}>
                    <div>
                        <EventBusyIcon className={classes.icon} />
                    </div>
                    <Typography
                        variant='body1'
                        component='div'
                        className={classes.text}
                    >
                        {text}
                    </Typography>
                </CardContent>
            </Card>
        );
    }
}

DealExpiredBox.propTypes = {
    text: PropTypes.string.isRequired,
};

export default function _DealExpiredBox(props) {
    const classes = useStyles();
    return <DealExpiredBox {...props} classes={classes} />;
}
